import React, { useMemo, useState } from 'react';
import showdown from 'showdown';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';

const ResponsiveEllipsis = responsiveHOC()(HTMLEllipsis);

const converter = new showdown.Converter();
const DEFAULT_LINE_CLAMP = 2;

interface PageDescClampProps {
  text: string;
}

const PageDescClamp: React.FC<PageDescClampProps> = ({ text }) => {
  const [isClamped, setClamped] = useState(false);
  const [lines, setLines] = useState(DEFAULT_LINE_CLAMP);

  const html = useMemo(() => converter.makeHtml(text ?? ''), [text]);

  return (
    <div>
      <ResponsiveEllipsis
        component="div"
        unsafeHTML={html}
        maxLine={lines}
        basedOn="letters"
        ellipsis="…"
        onReflow={({ clamped }: { clamped: boolean }) => setClamped(clamped)}
      />

      {isClamped && (
        <button
          className="clamp-button"
          type="button"
          onClick={() => setLines(100)}
        >
          Read More
        </button>
      )}

      {!isClamped && lines !== DEFAULT_LINE_CLAMP && (
        <button
          className="clamp-button"
          type="button"
          onClick={() => setLines(DEFAULT_LINE_CLAMP)}
        >
          Read Less
        </button>
      )}
    </div>
  );
};

export default PageDescClamp;
